module.exports = __webpack_public_path__ + "static/media/Administrative Penalty Order - Paul Starkman.3e3cd51f.pdf";